import { API_FAILURE } from './index';

export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';

// Local options related events
export const AP_COLUMNS_VISIBILITY_CHANGED = 'AP_COLUMNS_VISIBILITY_CHANGED';
export const apColumnsVisibilityChanged = (options) => ({
  type: AP_COLUMNS_VISIBILITY_CHANGED,
  meta: { options: options },
})

export const AP_TAB_CHANGED = 'AP_TAB_CHANGED';
export const apTabChanged = (idx, anchor = null) => ({
  type: AP_TAB_CHANGED,
  meta: { idx, anchor },
});

export const GH_COLUMNS_VISIBILITY_CHANGED = 'GH_COLUMNS_VISIBILITY_CHANGED';
export const ghColumnsVisibilityChanged = (options) => ({
  type: GH_COLUMNS_VISIBILITY_CHANGED,
  meta: { options: options },
})

// Modals related events
export const hideModal = () => ({
  type: HIDE_MODAL,
})

export const showASQModal = (withPlayer, scroll) => (dispatch, getState) => {
  const meta = { scroll };
  if (withPlayer) {
    const state = getState();
    meta.playerId = state.player.player.id;
    meta.players = [{ value: state.player.player.id, label: state.player.player.name }];
  }
  return dispatch({
    type: SHOW_MODAL,
    modalType: 'START_ASQ',
    modalProps: {},
    meta,
  });
}

/**
 * @deprecated Use showNewMessageModal from actions/communication.jsx instead
 * This modal has been replaced by CommunicationMessageModalContainer
 * which provides better customization and reusability.
 */
export const showBulkSendingModal = (props = {}) => ({
  type: SHOW_MODAL,
  modalType: 'BULK_SENDING',
  modalProps: props,
});

export const showPlayerQuestionModal = (qId) => ({
  type: SHOW_MODAL,
  modalType: 'QUESTION_DETAILS',
  modalProps: {qId},
});

export const showQuestionNotesModal = (asqQuestionId, qNumber, hasNotes) => ({
  type: SHOW_MODAL,
  modalType: 'QUESTION_NOTES',
  modalProps: {asqQuestionId, qNumber, hasNotes},
});

export const showSurveyNotesModal = () => ({
  type: SHOW_MODAL,
  modalType: 'SURVEY_NOTES',
  modalProps: {},
})

export const showReportDetailsModal = (report, modalType) => ({
  type: SHOW_MODAL,
  modalType: modalType,
  modalProps: {report},
});

export const PLAYERS_FILTER_CLEAR = 'PLAYERS_FILTER_CLEAR';

export const playersFilterClear = (source) => ({
  type: PLAYERS_FILTER_CLEAR,
  meta: { source: source },
})

export const SURVEYS_FILTER_CHANGE = 'SURVEYS_FILTER_CHANGE';

export const surveysFilterChange = (value) => ({
  type: SURVEYS_FILTER_CHANGE,
  meta: {qId: value},
})

export const RESET_ERROR_MESSAGE = 'RESET_ERROR_MESSAGE';

// Resets the currently visible error message.
export const resetErrorMessage = (meta = { status: false }) => ({
  type: RESET_ERROR_MESSAGE,
  meta,
})

export const ERROR_MESSAGE = 'ERROR_MESSAGE';

// Sends error to show
export const errorMessage = (msg, messageType = 'alert') => ({
  type: ERROR_MESSAGE,
  payload: { errors: [msg], messageType },
})

export const apiFailure = (msg, messageType = 'alert') => ({
  type: API_FAILURE,
  payload: { errors: [msg], messageType },
})

export const customMessage = (msg, messageType) => ({
  type: 'CUSTOM_MESSAGE',
  payload: { message: msg, messageType },
})

export const clearMessage = () => ({
  type: 'CLEAR_MESSAGE',
  payload: { },
})
